import { Campaign } from './campaign'
import { EmailValidity } from './contacts'
import { User } from './user'

export enum ContactRequestJobStatus {
  SUBMITTED = 0,
  STARTED = 10,
  PENDING_APPROVAL = 20,
  ACCEPTED = 30,
  REJECTED = 40,
  CANCELLED = 50,
}

export interface ContactRequestJobResponse {
  id: number
  company: number
  user: User
  max_contacts: number
  status: { id: number; label: string }
  created: string
  modified: string
  found_active_count: number
  found_companies_count: number
  credits_used: number
  sub_category: {
    id: number
    name: string
    description: string
  }
  contact_companies: Array<{
    id: number
    name: string
  }>
  campaign: Campaign
  unique_companies_count: number
}

export interface RequestedContactResponse {
  id: number
  chain_proxy: {
    id: number
    name: string
  }
  status: {
    id: number
    label: string
  }
  contact: string
  pdl_id: string
  title: string
  seniority?: string
  department?: string
  email_work_validity?: EmailValidity
  email_personal_validity?: EmailValidity
  email_generic_validity?: EmailValidity
  first_name_found: boolean
  last_name_found: boolean
  phone_number_found: boolean
  email_work_found: boolean
  email_personal_found: boolean
  email_generic_found: boolean
  linkedin_url_found: boolean
  metadata: any
}
